import { PcsAxisCharacter } from '../../types/code.types';

interface CodeStructureProps {
  axisBreakdown: PcsAxisCharacter[];
}

const CodeStructure = ({ axisBreakdown }: CodeStructureProps) => {
  if (axisBreakdown.length === 0) return null;
  const sorted = [...axisBreakdown].sort((a, b) => a.position - b.position);
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">🧩 Code Structure</h2>
      <div className="space-y-2">
        {sorted.map((axis) => (
          <div key={axis.position} className="p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <span className="flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-lg bg-primary-100 text-primary-700 font-mono font-bold">{axis.position}</span>
              <div>
                <p className="text-sm text-gray-500">{axis.title}</p>
                <p className="text-gray-800 font-medium">{axis.value}</p>
              </div>
            </div>
            {axis.definition && (
              <div className="mt-2 pl-12">
                <p className="text-sm text-gray-700">{axis.definition}</p>
                {axis.explanation && <p className="text-sm text-gray-500 mt-1">Explanation: {axis.explanation}</p>}
                {axis.includes && <p className="text-sm text-gray-500 mt-1">Includes: {axis.includes}</p>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CodeStructure;
